module.exports = __webpack_public_path__ + "91ce87791d0e3da6f5252609a59e707f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/quiz-3.png
// module id = 1128
// module chunks = 0